import * as React from "react";
import { SVGProps } from "react";
const SvgCalendar = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17 23h3v-3h-3v3Zm0-5h3v-3h-3v3Zm-5 5h3v-3h-3v3Zm0-5h3v-3h-3v3Zm10 5h3v-3h-3v3Zm7-15c0-1.1-.9-2-2-2h-4V4c0-.6-.4-1-1-1s-1 .4-1 1v2H11V4c0-.6-.4-1-1-1s-1 .4-1 1v2H5c-1.1 0-2 .9-2 2v17c0 1.1.9 2 2 2h22c1.1 0 2-.9 2-2V8Zm-2 17H5V8h22v17Zm-5-7h3v-3h-3v3Zm-12 2H7v3h3v-3Zm0-5H7v3h3v-3Zm15-5H7v3h18v-3Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCalendar;
